<template>
<transition name="slideRight">
<div class="container">
  <form class="form">
    <div class="form-group">
      <label>Workout Date</label>
      <input type="date" class="form-control" v-model="workoutDate" placeholder="Workout Date" @input="changesMade" />
    </div>
    <div class="btn-group btn-group-toggle mb-3" data-toggle="buttons">
      <label class="btn btn-outline-primary" :class="[{active: metconOrLift == 'metcon'}, validClass.workoutType]">
        <input type="radio" name="options" @click.prevent="setType('metcon')" autocomplete="off" :checked="metconOrLift == 'metcon'"> Metcon
      </label>
      <label class="btn btn-outline-primary" :class="[{active: metconOrLift == 'lift'}, validClass.workoutType]">
        <input type="radio" name="options" @click.prevent="setType('lift')" autocomplete="off" :checked="metconOrLift == 'lift'"> Lift
      </label>
      <label class="btn btn-outline-primary" :class="[{active: metconOrLift == 'other'}, validClass.workoutType]">
        <input type="radio" name="options" @click.prevent="setType('other')" autocomplete="off" :checked="metconOrLift == 'other'"> Other
      </label>
    </div>
    <small class="mt-2 text-danger" v-show="validClass.workoutType == 'is-invalid'">Please Choose One</small>

    <div v-show="metconOrLift == 'lift'">
      <toggle-button v-model="workout.oneRepMax" color="#2780E3" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :height="33" :width="68" @input="changesMade"/>
      <label>Was this lift a 1 rep max attempt?</label>
    </div>
    <div class="form-group" v-if="workout.oneRepMax">
      <label>Ok, What Lift?</label>
      <select v-model="workout.liftType" class="form-control" :class="[validClass.liftType]" @input="changesMade">
        <option disabled value="">Please select one</option>
        <option v-for="lift in liftTypes" :key="lift.id">{{lift.name}}</option>
      </select>
    </div>
    <div v-show="metconOrLift == 'metcon'">
      <toggle-button v-model="workout.isNamedWod" color="#2780E3" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :height="33" :width="68" @input="changesMade"/>
      <label>Was this a 'Named' Girl, Hero, or Open Wod?</label>
    </div>
    <div class="form-group" v-if="workout.isNamedWod">
      <label>Ok, Which Wod?</label>
      <select v-model="workout.namedWod" class="form-control" :class="[validClass.namedWod]" @input="changesMade">
        <option disabled value="">Please select one</option>
        <option v-for="wod in namedWods" :key="wod.id" :value="wod">{{wod.name}}</option>
      </select>
      <label>WOD Description:</label>
      <textarea rows="4" class="form-control" v-model="workout.namedWod.description"></textarea>
    </div>
    <div class="form-group" v-if="workout.oneRepMax || workout.isnamedWod">
      <label>Any additional lift description?</label>
      <textarea rows="2" class="form-control" v-model="workout.description" placeholder="Workout Description" @input="changesMade"></textarea>
    </div>
    <div class="form-group" v-else>
      <label>Workout Description</label>
      <textarea rows="7" class="form-control" :class="[validClass.description]" v-model="workout.description" placeholder="Workout Description... Hint: Go to your box's website and copy and paste your workout here." @input="changesMade"></textarea>
      <small v-if="validClass.description == 'is-invalid'" class="text-danger form-text">A workout must have a description!</small>
    </div>

    <div class="form-group" v-if="workout.oneRepMax">
      <label>Max lifted Weight?</label>
      <div class="input-group"> 
        <input type="text" class="form-control col-6" :class="[validClass.result]" style="display:inline;" v-model="workout.result" placeholder="e.g. 225" @input="changesMade"/>
        <div class="input-group-append"><span class="input-group-text"> lbs/kgs</span></div>
      </div>
      <small class="helper-text">Please enter only the exact lb or kg lifted.</small>
    </div>
    <div class="form-group" v-else-if="workout.isNamedWod">
      <label>Result</label>
      <div v-if="workout.namedWod.resultMeasure == 'time or reps and tiebreak'">
        <input type="text" class="form-control col-5" :class="[validClass.result]" style="display:inline;" v-model="workout.result" placeholder="Time or Reps" @input="changesMade"/>
        <input type="text" class="form-control col-6" :class="[validClass.result]" style="display:inline;" v-model="workout.resultTieBreak" placeholder="Tie Break Time" @input="changesMade"/>
        <small class="helper-text">{{workout.namedWod.resultDesc}}</small>      
      </div>
      <div v-else class="input-group"> 
        <input v-if="workout.namedWod.resultMeasure == 'time'" type="text" class="form-control col-6" :class="[validClass.result]" style="display:inline;" v-model="workout.result" placeholder="e.g. 4:55" @input="changesMade"/>
        <input v-else-if="workout.namedWod.resultMeasure == 'total weight'" type="text" class="form-control col-6" :class="[validClass.result]" style="display:inline;" v-model="workout.result" placeholder="e.g. 25" @input="changesMade"/>
        <input v-else-if="workout.namedWod.resultMeasure == 'total reps'" type="text" class="form-control col-6" :class="[validClass.result]" style="display:inline;" v-model="workout.result"  placeholder="e.g. 25" @input="changesMade"/>
        <input v-else type="text" class="form-control col-6" :class="[validClass.result]" style="display:inline;" v-model="workout.result" placeholder="e.g. 6+4" @input="changesMade"/>
        <div class="input-group-append"><span class="input-group-text"> {{workout.namedWod.resultMeasure}}</span></div>
      </div>
    </div>
    <div class="form-group" v-else>
      <label>Result</label>
      <input type="text" class="form-control" :class="[validClass.result]" v-model="workout.result" placeholder="5+1 or 3:45 or 245#, etc..." @input="changesMade"/>
      <small v-if="validClass.result == 'is-invalid'" class="text-danger form-text">You must enter a result!</small>
    </div>
    
    <div v-show="metconOrLift == 'metcon'">
      <toggle-button v-model="workout.rx" color="#2780E3" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :height="33" :width="68" @input="changesMade"/>
      <label>Workout Performed RX?</label>
      <br/>
    </div>
    <toggle-button v-model="workout.pr" color="#2780E3" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :height="33" :width="68" @input="changesMade"/>
    <label>Personal Record? (PR)</label>

    <div class="form-group">
      <label>Tags</label>
      <input type="text" class="form-control" v-model="tagString" placeholder="#Clean&Jerk, #hurt" @input="changesMade" />
      <small class="helper-text">Tags must start with #, Have no spaces, and be seperated by commas.</small>
    </div>
    <div class="form-group">
      <label>Any Additional Notes?</label>
      <input type="text" class="form-control" v-model="workout.notes" placeholder="i.e. Unbroken DU's!, or Hurt shin on boxjumps, etc..." @input="changesMade"/>
      <small class="helper-text">This can be anything you want...</small>
    </div>

  </form>
  <hr>
  
  <button v-if="!workoutId" class="btn btn-outline-primary btn-block mb-5" @click="saveWorkout"><icon name="save" /> Save Workout</button>
  <button v-if="workoutId" class="btn btn-outline-primary btn-block mb-2" @click="commitUpdates"><icon name="save" /> Save Updates to Workout</button>
  <button v-if="workoutId" class="btn btn-outline-danger btn-block" @click="confirmDelete"><icon name="trash" /> Delete Workout</button>

  <kDialog :showModal="showModal" typeClass="danger" transition="modal">
    <h1 slot="header" class="centerTitle"><icon name="hand-paper-o" scale="3"/> Stop</h1>
    <div slot="body" class="centerBody">
      <h3>Are you sure you want to delete this workout?</h3>
      <h6>This can't be undone.</h6>
    </div>
    <span slot="footer">
      <button class="btn btn-outline-light btn-lg ml-2 col-4" @click="showModal = false"><icon name="ban" /> Cancel</button>
      <button class="btn btn-outline-dark btn-lg col-6" @click.prevent="deleteWorkout"><icon name="trash"/> Delete</button>
    </span>
  </kDialog>
</div>
</transition>
</template>

<script>
import firebase from 'firebase'
import format from 'date-fns/format'
import kDialog from '@/components/kDialog'

//import Workout from '@/workoutData.js'

export default {
  name: 'workout',
  components: {
    kDialog
  },
  data () {
    return {
      workout : {
          date: "",
          workoutType: "",
          description: "",
          result: "",
          resultTieBreak: "",
          rx: false,
          pr: false, 
          oneRepMax: false,
          liftType: "",
          tags: [],
          notes: "",  
          isNamedWod: false,
          namedWod: "" 
      },
      validClass: {
        workoutType: "valid",
        description: "valid",
        result: "valid",
        liftType: "valid"
      },
      format: format,
      updateChanges: false,
      tagString: "",
      workoutDate: "",
      formErrors: [],
      showModal: false
    }
  },
  computed: {
    workoutId () {
      if(this.$route.params.id != 0) {
        return this.$route.params.id
      } else {
        return undefined
      }
    },
    liftTypes () {
      return this.$store.state.liftTypes
    },
    namedWods () {
      return this.$store.state.namedWods
    },
    workouts () {
      return this.$store.state.workouts
    },
    authUser () {
      return this.$store.state.authUser
    },
    user () {
      return this.$store.state.user
    },
    userId () {
      return this.$store.getters.userId
    },
    db () {
      return this.$store.state.db
    },
    metconOrLift: function () {
      if(this.workout.workoutType == 'metcon') {
        return 'metcon'
      } else if (this.workout.workoutType == 'lift') {
        return 'lift'
      } else if (this.workout.workoutType == 'other') {
        return 'other'
      } else {
        return 'noSelection'
      }
    }
  },
  created () {
    if(this.workoutId){
      console.log("This is an existing workout... looking up data.")
      this.db.collection('users').doc(this.userId).collection('workouts').doc(this.workoutId).get()
      .then(workout => {
        console.log("data found...")
        this.workout = workout.data()
        this.tagString = this.workout.tags.join()
        this.workoutDate = format(this.workout.date, 'YYYY-MM-DD')
      })
    } else {
      console.log("This is a new workout... no id.")
      this.workoutDate = format(new Date(), 'YYYY-MM-DD')
    }

    this.$store.commit('setLiftTypes')
    this.$store.commit('setNamedWods')
  },
  methods: {
    setType: function(type) {
      this.workout.workoutType = type
      this.updateChanges = true
      if (type == 'other') {
        this.workout.oneRepMax = false
        this.workout.liftType = ""
        this.workout.isNamedWod = false
        this.workout.namedWod = ""
      }
      if (type == 'metcon') {
        this.workout.oneRepMax = false
        this.workout.liftType = ""
      }
      if (type == 'lift') {
        this.workout.isNamedWod = false
        this.workout.namedWod = ""
      }
    },
    changesMade: function () {
      this.updateChanges = true
    },
    saveWorkout: function () {

      let isValid = this.formValid()

      if(isValid){
        let workoutPayload = this.workout
        workoutPayload.date = new Date(format(this.workoutDate))
        workoutPayload.tags = this.tagString.split(",").map(item => { return item.trim() })

        //console.log(workoutPayload)
        
        this.$store.dispatch('saveNewWorkout', workoutPayload)
        .then(() => {
            this.$notify({
            group: 'note',
            text: 'Wokout Added!',
            type: 'save'
          })
        })

        
      } else {
        let errorTxt = ""
        this.formErrors.forEach((err,index) => {
          errorTxt += `${index+1}. ${err}<br/>`
        })

        this.$notify({
          group: 'note',
          text: errorTxt,
          type: 'error'
        })

      }

      

    },
    commitUpdates: function () {

      let isValid = this.formValid()

      if(isValid) {
        let workoutPayload = {
          workoutId: this.workoutId,
          workout: this.workout
        }
        workoutPayload.workout.date = new Date(format(this.workoutDate))
        workoutPayload.workout.tags = this.tagString.split(",").map(item => { return item.trim() })

        //console.log(workoutPayload['workout'])
        this.$store.dispatch('updateWorkout', workoutPayload)
        .then(() => {
          this.$notify({
              group: 'note',
              text: 'Wokout Saved!',
              type: 'save'
            })
        })
      } else {
        let errorTxt = ""
        this.formErrors.forEach((err,index) => {
          errorTxt += `${index+1}. ${err}<br/>`
        })

        this.$notify({
          group: 'note',
          text: errorTxt,
          type: 'error'
        })
      }

      
    },
    confirmDelete: function() {
      this.showModal = true
    },
    deleteWorkout: function () {
      console.log(`Delete Workout selected.`)
      this.$store.dispatch('deleteWorkout', this.workoutId)
      .then(() => {
          this.$notify({
              group: 'note',
              text: 'Wokout Deleted Successfully',
              type: 'save'
            })      
          this.showModal = false 
      })
      
      
    },
    formValid: function() {
      //reset all values
      this.formErrors = []
      this.validClass.workoutType = 'valid'
      this.validClass.description = 'valid'
      this.validClass.result = 'valid'
      this.validClass.liftType = 'valid'

      if(this.workout.workoutType == ""){
        this.validClass.workoutType = "is-invalid"
        this.formErrors.push("Workout type must be either 'Metcon', 'Lift', or 'Other'.")
      } 
      if (this.workout.description == "" && !this.workout.oneRepMax && !this.workout.isNamedWod){
        this.validClass.description = "is-invalid"
        this.formErrors.push("Workout 'Description' can not be blank.")
      } 
      if (this.workout.result == ""){
        this.validClass.result = "is-invalid"
        this.formErrors.push("Workout 'Result' can not be blank.")
      } else if (this.workout.oneRepMax == true){
        //make sure result only contains digits 0-9
        let validResult = /^\d+$/.test(this.workout.result)
        if(!validResult) {
          this.validClass.result = "is-invalid"
          this.formErrors.push("'Result' can only contain numbers. As in '415' not '415 lbs' ")
        }
      } else if (this.workout.isNamedWod == true ){

      }
      if (this.workout.oneRepMax == true && this.workout.liftType.trim() == '') {
        this.validClass.liftType = "is-invalid"
        this.formErrors.push("If this was a 1 rep max attempt, what lift was it?")
      }

      if (this.formErrors.length == 0) {
        return true
      } else {
        return false
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vue-js-switch {
  font-size: 15px;
}

</style>


// WEBPACK FOOTER //
// src/components/workout.vue